export function usePrice (
  minimumFractionDigits?: Ref<number> | number,
  locale = 'pl-PL'
) {
  return computed(() => 
    new Intl.NumberFormat(locale, {
      minimumFractionDigits: unref(minimumFractionDigits)
    })
  )
}